import React from 'react'

const Button = ({ text,onClick,borderBlue,textcolor }) => {
  return (
    <button className={`border-1 border-solid flex flex-row   items-center px-3.5 py-2.5 ${textcolor} font-normal text-12 rounded-sm leading-5.4 gap-2.2 h-10 ${borderBlue}  `} onClick={onClick}>
      {text}
    </button>
  )
}

export default Button
